import { defineMessages, useIntl } from 'react-intl';

import { InAppErrorMessageFallback } from './InAppErrorMessageFallback';

const messages = defineMessages({
  noOrgsTitle: {
    id: 'Navigation.noOrgsTitle',
    defaultMessage: "You don't have access to Workspace",
    description:
      'Title shown when the workspace organization list is empty (no orgs or insufficient access)',
  },
  noOrgsBody: {
    id: 'Navigation.noOrgsBody',
    defaultMessage: 'Please contact your administrator.',
    description:
      'Body shown when the workspace organization list is empty (no orgs or insufficient access)',
  },
});

export function NoOrganizationsFallback() {
  const { formatMessage } = useIntl();
  return (
    <InAppErrorMessageFallback
      align="start"
      pictogramName="walletAsServiceNavigation"
      title={formatMessage(messages.noOrgsTitle)}
      description={formatMessage(messages.noOrgsBody)}
    />
  );
}
